import React, { useEffect, useState } from 'react';
import axiosInstance from "../../../axios";
import config from "../../../config";
import { Empty, Spin, Table } from 'antd';
import stringHelper from "../../../utils/strings";
import moment from 'moment-jalaali';
import { usePersistedStore } from '../../../store/persisted-store';
import { useReportsStore } from '../../../store/slices/createReportsSlice';

function InsuranceInfoHistory(props) {
    const { business } = usePersistedStore();
    const reports = useReportsStore()
    const [historyList, setHistoryList] = useState([]);
    const token = business.currentBusiness.token;
    const requestId = reports.insuranceDetails.infos.InsuranceRequestId;
    const [loading, setLoading] = useState(false);

    const data = historyList?.Histories;


    useEffect(() => {
        if (props.tab == 5 && stringHelper.hasValue(requestId)) {
            setLoading(true)
            axiosInstance({
                method: "get",
                baseURL: config.apiUrls(),
                url: `/v1/crm/insurance/${requestId}/history`,
                headers: {
                    token
                },
            })
                .then((resp) => {
                    setHistoryList(resp.data)
                    setLoading(false)
                })
                .catch(e => {
                    setLoading(false)
                })

        }
    }, [props.tab]);

    const columns = [

        {
            title: "کارشناس صدور",
            dataIndex: "IssuingExpertFullName",
            key: "IssuingExpertFullName",
            width: 90,
        },
        {
            title: "کارشناس پشتیبان",
            dataIndex: "SupportExpertFullName",
            key: "SupportExpertFullName",
            width: 100,
        },
        {
            title: "نام شرکت",
            dataIndex: "CompanyName",
            key: "CompanyName",
            width: 70,
        },
        {
            title: 'تاریخ ثبت',
            dataIndex: 'CreationTime',
            key: 'CreationTime',
            width: 20,
            render: data => data && stringHelper.getFarsiNum(moment(data).format('jYYYY/jMM/jDD  ساعت:  HH:mm'))
        },
        {
            title: "تخفیف توافقی",
            dataIndex: "AgreementDiscountAmount",
            key: "AgreementDiscountAmount",
            width: 90,
            render: data => data && stringHelper.currencyFormat(data) + 'ریال',
        },
        {
            title: "درصد تخفیف توافقی",
            dataIndex: "AgreementDiscountPercent",
            key: "AgreementDiscountPercent",
            width: 110,
            render: data => data && stringHelper.getFarsiNum(data) + ' %',
        },
        {
            title: "تخفیف سایت",
            dataIndex: "SiteDiscountAmount",
            key: "SiteDiscountAmount",
            width: 80,
            render: data => data && stringHelper.currencyFormat(data) + ' ریال',
        },
        {
            title: "درصد تخفیف سایت",
            dataIndex: "SiteDiscountPercent",
            key: "SiteDiscountPercent",
            width: 110,
            render: data => data && stringHelper.getFarsiNum(data) + ' %',
        },
        {
            title: "مبلغ اولیه",
            dataIndex: "TotalAmount",
            key: "TotalAmount",
            width: 90,
            render: data => data && stringHelper.currencyFormat(data) + ' ریال',
        },

    ];
    return (
        <Spin spinning={loading}>
            {data ?
                <Table
                    style={{ overflowX: 'scroll' }}
                    bordered
                    columns={columns}
                    loading={loading}
                    // rowKey="InsuranceRequestId"
                    scroll={true}
                    dataSource={data}
                />
                :
                <Empty description={false} />
            }
        </Spin >
    )
}

export default InsuranceInfoHistory